import { z } from "zod";

/** New product form — mirrors createProduct body (plan/26 RHF + Zod). */
export const productNewSchema = z
  .object({
    name: z.string().trim().min(1, "Name is required"),
    sku: z.string().trim().optional(),
    barcode: z.string().trim().optional(),
    kind: z.enum(["stocked", "service"]),
    posPrice: z.string().trim().optional(),
    trackLot: z.boolean(),
    trackSerial: z.boolean(),
  })
  .transform((v) => ({
    name: v.name,
    sku: v.sku || undefined,
    barcode: v.barcode || undefined,
    kind: v.kind,
    posPrice: v.posPrice || undefined,
    trackLot: v.kind === "stocked" ? v.trackLot : false,
    trackSerial: v.kind === "stocked" ? v.trackSerial : false,
  }));

export type ProductNewInput = z.input<typeof productNewSchema>;
export type ProductNewValues = z.output<typeof productNewSchema>;
